import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import OnePageHeader from "../header/OnePageHeader";
import OnlyTitleHeader from "../header/OnlyTitleHeader";

const OnlyTitleHeaderLayout = ({ title, children }) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <OnlyTitleHeader title={title} isOpen={isOpen} />
      <Main>{children}</Main>
    </>
  );
};

export default OnlyTitleHeaderLayout;

const Main = styled.main`
  background-color: ${({ theme }) => theme.color.purple_bg};
`;
